import { memo } from 'react';

import { Form, InputNumber, Select, TimePicker } from 'antd';

function RuleStep({ step, onChange, rule }) {
  if (step.timeBased && !rule.timeBased) {
    return null;
  }

  return (
    <Form.Item label={step.name} name={step.key} colon={false} layout="vertical" style={{ flex: 1, minWidth: '150px' }}>
      {step.type === 'dropdown' && (
        <Select
          placeholder="Select"
          options={step.options}
          showSearch={step.key === 'anchor' || step.key === 'target'}
          onChange={(value, option) => onChange(option, step.key)}
        />
      )}
      {step.type === 'number' && (
        <InputNumber className="w-full" placeholder="0" min={0} onChange={value => onChange(value, step.key)} />
      )}
      {step.type === 'time' && (
        <TimePicker className="w-full" format="HH:mm" onChange={value => onChange(value, step.key)} />
      )}
    </Form.Item>
  );
}

export default memo(RuleStep);
